export function fuzzyExtractOperationTitle(str) {
    var _a;
    var regex = /^(?!.*#).*(query|subscription|mutation)\s+([a-zA-Z0-9_]+)/;
    var match = regex.exec(str);
    return (_a = match === null || match === void 0 ? void 0 : match[2]) !== null && _a !== void 0 ? _a : '<untitled>';
}
//# sourceMappingURL=fuzzyExtractOperationTitle.js.map